export const DOMAIN_NAME = "imbaweb.com"

export const FORM_MODE = {
  NEW: 'NEW',
  EDIT: 'EDIT',
  READ_ONLY: 'READ_ONLY'
}

export const DATA_TYPE = {
  'STRING': 'STRING',
  'UUID': 'UUID',
  'TEXT': 'TEXT',
  'BOOLEAN': 'BOOLEAN',
  'INTEGER': 'INTEGER',
  'SEQUENCE': 'SEQUENCE',
  'DECIMAL': 'DECIMAL',
  'MONEY': 'MONEY',
  'DATETIME': 'DATETIME',
  'DATE': 'DATE',
  'LIST_GROUP': 'LIST_GROUP',
  'MODEL': 'MODEL',
  'JSON': 'JSON',
  'COMPOSITE': 'COMPOSITE'
}

export const DATA_TYPE_TO_GRAPHQL = {
  'STRING': 'String',
  'UUID': 'String',
  'TEXT': 'String',
  'BOOLEAN': 'Boolean',
  'INTEGER': 'Int',
  'SEQUENCE': 'Int',
  'DECIMAL': 'Float',
  'MONEY': 'Float',
  'DATETIME': 'DateTime',
  'DATE': 'Date',
  'LIST_GROUP': 'String',
  'MODEL': 'String',
  'JSON': 'String',
  'COMPOSITE': 'String'
}

export const TENANT_NAME = window.TENANT_NAME

// ---------- IMAGE BUCKET  ---------- 

export const GLOBAL_BUCKET = `https://storage.googleapis.com/images.imbaweb.com`

export const TENANT_BUCKET = `https://storage.googleapis.com/${TENANT_NAME}-images.imbaweb.com`

// ---------- DESIGNER MODE  ---------- 

export const DESIGNER_MODE = false

// ---------- LANGUAGE ---------- 

// export const LANGUAGE = {
//   en: { nativeName: 'English' },
//   bm: { nativeName: 'Malay' },
//   zh: { nativeName: '中文' }
// }

// ---------- HEADER MENU ---------- 

export const HEADER_MENU_DATA = {

  "HOME": {
    name: "home",
    icon: `${TENANT_BUCKET}/icon/menu_home.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/menu_home_active.png`,
    mobileShow: true,
    url: "/",
  },

  "OVERVIEW": {
    name: "overview",
    icon: `${TENANT_BUCKET}/icon/menu_overview.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/menu_overview_active.png`,
    mobileShow: true,
    url: "/overview",
    isLogin:true
  },

  "REPORT": {
    name: "report",
    icon: `${TENANT_BUCKET}/icon/menu_report.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/menu_report_active.png`,
    mobileShow: true,
    url: "/wallet/report",
    isLogin:true
  },

  "COMMISSION_PLAN": {
    name: "commission_plan",
    icon: `${TENANT_BUCKET}/icon/menu_casino.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/menu_commissionPlan_active.png`,
    mobileShow: true,
    url: "/commission-plan",
  },

  "HELP": {
    name: "help",
    icon: `${TENANT_BUCKET}/icon/menu_help.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/menu_help_active.png`,
    mobileShow: true,
    url: "/help",
  }
}

// ---------- FOOTER MENU ---------- 

export const FOOTER_MENU_DATA = {

  "ABOUT_US": {
    name: "about_us",
    mobileShow: true,
    url: "/help#about-us",
  },

  "TNC": {
    name: "tnc",
    mobileShow: true,
    url: "/help#term-and-conditions",
  },

  "FAQ": {
    name: "faq",
    mobileShow: true,
    url: "/help#faq",
  },

  "HOW_TO_DEPOSIT": {
    name: "how_to_deposit",
    mobileShow: true,
    url: "/help#how-to-deposit",
  },

  "HOW_TO_TRANSFER": {
    name: "how_to_transfer",
    mobileShow: true,
    url: "/help#how-to-transfer",
  },

  "HOW_TO_WITHDRAW": {
    name: "how_to_withdrawal",
    mobileShow: true,
    url: "/help#how-to-withdraw",
  },

  "CONTACT_US": {
    name: "contact_us",
    mobileShow: true,
    url: "/contact-us",
  },

  "VIP": {
    name: "vip",
    mobileShow: true,
    url: "/vip",
  }
}

// ---------- GAME MENU ---------- 

export const GAME_MENU_DATA = {

  "SL": {
    gameType: 'SL',
    name: "slots",
    icon: `${TENANT_BUCKET}/icon/game_menu_slot.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/game_menu_slot_active.png`,
    url: "/slots",
  },

  "LC": {
    gameType: 'LC',
    name: "live_casino",
    icon: `${TENANT_BUCKET}/icon/game_menu_casino.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/game_menu_casino_active.png`,
    url: "/live-casino",
  },

  "APP": {
    gameType: 'APP',
    name: "mobile_slot",
    icon: `${TENANT_BUCKET}/icon/game_menu_mslot.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/game_menu_mslot_active.png`,
    url: "/mobile-slots",
  },

  "ES": {
    gameType: 'ES',
    name: "e-sport",
    icon: `${TENANT_BUCKET}/icon/game_menu_esport.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/game_menu_esport_active.png`,
    url: "/esport",
  },

  "SB": {
    gameType: 'SB',
    name: "sport",
    icon: `${TENANT_BUCKET}/icon/game_menu_sport.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/game_menu_sport_active.png`,
    url: "/sports",
  },

  "LK": {
    gameType: 'LK',
    name: "lottery",
    icon: `${TENANT_BUCKET}/icon/game_menu_lottery.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/game_menu_lottery_active.png`,
    url: "/lottery",
  },

  "FH": {
    gameType: 'FH',
    name: "fishing",
    icon: `${TENANT_BUCKET}/icon/game_menu_fishing.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/game_menu_fishing_active.png`,
    url: "/fishing",
  },

  "CB": {
    gameType: 'CB',
    name: "boardgame",
    icon: `${TENANT_BUCKET}/icon/game_menu_boardgame.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/game_menu_boardgame_active.png`,
    url: "/board-game",
  },

  "PK": {
    gameType: 'PK',
    name: "poker",
    icon: `${TENANT_BUCKET}/icon/game_menu_poker.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/game_menu_poker_active.png`,
    url: "/poker",
  }
  ,
  "MG": {
    gameType: 'MG',
    name: "mini_game",
    icon: `${TENANT_BUCKET}/icon/game_menu_mini_game.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/game_menu_mini_game_active.png`,
    url: "/mini-game",
  },
  "OT": {
    gameType: 'OT',
    name: "others",
    icon: `${TENANT_BUCKET}/icon/game_menu_others.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/game_menu_others_active.png`,
    url: "/others",
  }


}

// ---------- SLOT ---------- 

export const SLOT_GAME_TYPE = {

  "ALL": {
    gameType: 'ALL',
    name: "all",
    label: 'gameType_all'
  },

  "SL": {
    gameType: 'SL',
    name: "slots",
    label: 'gameType_slots'
  },

  "AR": {
    gameType: 'AR',
    name: "arcade",
    label: 'gameType_arcade'
  },

  "LC": {
    gameType: 'LC',
    name: "table",
    label: 'gameType_table'
  },

  "FH": {
    gameType: 'FH',
    name: "fishing",
    label: 'gameType_fishing'
  },

  "LK": {
    gameType: 'LK',
    name: "lottery",
    label: 'lottery'
  },

  "OT": {
    gameType: 'OT',
    name: "other",
    label: 'other'
  },

  "BG": {
    gameType: 'BG',
    name: "bingo",
    label: 'bingo'
  },

  "FG": {
    gameType: 'FG',
    name: "featured games",
    label: 'featured games'
  },

  "FK": {
    gameType: 'FK',
    name: "funky",
    label: 'funky'
  },

  "MP": {
    gameType: 'MP',
    name: "multiplayer",
    label: 'multiplayer'
  },

  "SC": {
    gameType: 'SC',
    name: "scratch cards",
    label: 'scratch cards'
  },

  "SP": {
    gameType: 'SP',
    name: "single player",
    label: 'single player'
  },

  "TB": {
    gameType: 'TB',
    name: "table",
    label: 'gameType_table'
  },
}

// ---------- WALLET MENU ---------- 

export const WALLET_MENU_DATA =
{
  funds: [{
    id: "0",
    name: "deposit",
    mobileName: 'deposit',
    icon: `${TENANT_BUCKET}/icon/bankingInfo_menu_deposit.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/bankingInfo_menu_deposit_active.png`,
    url: "/wallet/deposit",

  }, {
    id: "1",
    name: "transfer",
    mobileName: 'transfer',
    icon: `${TENANT_BUCKET}/icon/bankingInfo_menu_transfer.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/bankingInfo_menu_transfer_active.png`,
    url: "/wallet/transfer",

  }, {
    id: "2",
    name: "withdraw",
    mobileName: 'withdraw',
    icon: `${TENANT_BUCKET}/icon/bankingInfo_menu_withdrawal.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/bankingInfo_menu_withdrawal_active.png`,
    url: "/wallet/withdraw",

  }, {
    id: "3",
    name: "report",
    mobileName: 'report',
    icon: `${TENANT_BUCKET}/icon/bankingInfo_menu_report.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/bankingInfo_menu_report_active.png`,
    url: "/wallet/report",

  }],
  my_account: [{
    id: "4",
    name: "user_info",
    mobileName: 'user_info',
    icon: `${TENANT_BUCKET}/icon/myAccount_menu_userInfo.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/myAccount_menu_userInfo_active.png`,
    url: "/wallet/user_info",

  }, {
    id: "5",
    name: "change_password",
    mobileName: 'change_password',
    icon: `${TENANT_BUCKET}/icon/myAccount_menu_changePassword.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/myAccount_menu_changePassword_active.png`,
    url: "/wallet/change_password",

  }, {
    id: "6",
    name: "banking_details",
    mobileName: 'banking_details',
    icon: `${TENANT_BUCKET}/icon/myAccount_menu_bankingDetails.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/myAccount_menu_bankingDetails_active.png`,
    url: "/wallet/banking_details",

  }]
}

// ---------- DEPOSIT MENU ---------- 

export const DEPOSIT_MENU_DATA = {

  "quickpay": {
    name: "quickpay",
    icon: `${TENANT_BUCKET}/icon/deposit_quickPay.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/deposit_quickPay_active.png`,
  },

  "banktransfer": {
    name: "banktransfer",
    icon: `${TENANT_BUCKET}/icon/deposit_bankTransfer.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/deposit_bankTransfer_active.png`,
  },

  "qrpay": {
    name: "qrpay",
    icon: `${TENANT_BUCKET}/icon/deposit_qrPay.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/deposit_qrPay_active.png`,
  },

  "reload": {
    name: "reload",
    icon: `${TENANT_BUCKET}/icon/deposit_reload.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/deposit_reload_active.png`,

  }
}

// ---------- WITHDRAW MENU ---------- 

export const WITHDRAW_MENU_DATA = {

  "banktransfer": {
    name: "banktransfer",
    icon: `${TENANT_BUCKET}/icon/deposit_bankTransfer.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/deposit_bankTransfer_active.png`,
  },

}


// ---------- DEPOSIT METHOD DATA ----------


export const DEPOSIT_METHOD_DATA = {

  "truepay": {
    name: "truepay",
    label: "Truepay",
  },

  "ipay4u": {
    name: "ipay4u",
    label: "Ipay4u",
  },

  "online_transfer": {
    name: "online_transfer",
    label: "Online Transfer",
  },

  "atm_cash_deposit": {
    name: "atm_cash_deposit",
    label: "ATM Cash Deposit",
  },

  "cash_deposit": {
    name: "cash_deposit",
    label: "Cash Deposit",
  }
}

// ---------- BANK DATA ----------

export const BANK_DATA = {

  "PHBMMYKL": {
    id: "PHBMMYKL",
    name: "Affin Bank",
    country: 'MY',
    icon: `${GLOBAL_BUCKET}/bank/MYR/PHBMMYKL.png`,
    qrIcon: `${TENANT_BUCKET}/bank-qrcode/PHBMMYKL.png`
  },

  "ARBKMYKL": {
    id: "ARBKMYKL",
    name: "Ambank",
    country: 'MY',
    icon: `${GLOBAL_BUCKET}/bank/MYR/ARBKMYKL.png`,
    qrIcon: `${TENANT_BUCKET}/bank-qrcode/ARBKMYKL.png`
  },

  "BIMBMYKL": {
    id: "BIMBMYKL",
    name: "Bank Islam Malaysia",
    country: 'MY',
    icon: `${GLOBAL_BUCKET}/bank/MYR/BIMBMYKL.png`,
    qrIcon: `${TENANT_BUCKET}/bank-qrcode/BIMBMYKL.png`
  },

  "BSNAMYK1": {
    id: "BSNAMYK1",
    name: "Bank Simpanan National",
    country: 'MY',
    icon: `${GLOBAL_BUCKET}/bank/MYR/BSNAMYK1.png`,
    qrIcon: `${TENANT_BUCKET}/bank-qrcode/BSNAMYK1.png`

  },

  "HLBBMYKL": {
    id: "HLBBMYKL",
    name: "Hong Leong Bank Berhad",
    country: 'MY',
    icon: `${GLOBAL_BUCKET}/bank/MYR/HLBBMYKL.png`,
    qrIcon: `${TENANT_BUCKET}/bank-qrcode/HLBBMYKL.png`
  },

  "MBBEMYKL": {
    id: "MBBEMYKL",
    name: "Maybank Berhad",
    country: 'MY',
    icon: `${GLOBAL_BUCKET}/bank/MYR/MBBEMYKL.png`,
    qrIcon: `${TENANT_BUCKET}/bank-qrcode/MBBEMYKL.png`
  },

  "PBBEMYKL": {
    id: "PBBEMYKL",
    name: "Public Bank Berhad",
    country: 'MY',
    icon: `${GLOBAL_BUCKET}/bank/MYR/PBBEMYKL.png`,
    qrIcon: `${TENANT_BUCKET}/bank-qrcode/PBBEMYKL.png`
  },

  "RHBBMYKL": {
    id: "RHBBMYKL",
    name: "RHB Bank Berhad",
    country: 'MY',
    icon: `${GLOBAL_BUCKET}/bank/MYR/RHBBMYKL.png`,
    qrIcon: `${TENANT_BUCKET}/bank-qrcode/RHBBMYKL.png`
  },

  "CIBBMYKL": {
    id: "CIBBMYKL",
    name: "CIMB Bank",
    country: 'MY',
    icon: `${GLOBAL_BUCKET}/bank/MYR/CIBBMYKL.png`,
    qrIcon: `${TENANT_BUCKET}/bank-qrcode/CIBBMYKL.png`
  },
}

// ---------- QR DATA ----------

export const QR_DATA = {

  "duitnow": {
    id: "duitnow",
    name: "DuitNow QR",
    icon: `${GLOBAL_BUCKET}/qrpay/MYS/duitnow.jpg`,
  },
}

// ---------- TRANSACTION TYPE DATA ----------

export const TRANSACTION_TYPE_DATA = {

  "transfer": {
    name: "transfer",
    url: "/wallet/history/transfer"
  },

  "betting_summary": {
    name: "betting_summary",
    url: "/wallet/history/betting_summary"
  },

  "deposit_withdrawal": {
    name: "deposit_withdrawal",
    url: "/wallet/history/deposit_withdrawal"
  },

  "promotion_apply": {
    name: "promotion_apply",
    url: "/wallet/history/promotion_apply"
  },

  "rebate": {
    name: "rebate",
    url: "/wallet/history/rebate"
  },

  "bonus": {
    name: "bonus",
    url: "/wallet/history/bonus"
  },
}

// ---------- USER VERIFICATION DATA ----------

export const USER_VERIFICATION_DATA = [
  {
    id: "phone_validated",
    name: "phone_number",
    // icon:<FaMobileAlt />,
  },
  {
    id: "email_validated",
    name: "email",
  },
  {
    id: "dob_validated",
    name: "dob",
    // icon: <FaAddressCard />,
  }
]

// ---------- SOCIAL MEDIA DATA ----------

export const SOCIAL_MEDIA_DATA = {

  "LIVECHAT": {
    name: "LiveChat",
    category: 'contactUs',
    icon: `${TENANT_BUCKET}/icon/contactUs_chatwithus.png`,
  },

  "TELEGRAM": {
    name: "Telegram",
    category: 'contactUs',
    icon: `${TENANT_BUCKET}/icon/contactUs_telegram.png`,
  },

  "WHATSAPP": {
    name: "Whatsapp",
    category: 'contactUs',
    icon: `${TENANT_BUCKET}/icon/contactUs_whatsapp.png`,
  },

  "WECHAT": {
    name: "Wechat",
    category: 'contactUs',
    icon: `${TENANT_BUCKET}/icon/contactUs_wechat.png`,
  },
  "SIDEBAR_LIVECHAT": {
    name: "LiveChat",
    category: 'contactUs',
    icon: `${TENANT_BUCKET}/icon/sideBar_chatwithus.png`,
  },

  "SIDEBAR_TELEGRAM": {
    name: "Telegram",
    category: 'contactUs',
    icon: `${TENANT_BUCKET}/icon/sideBar_telegram.png`,
  },

  "SIDEBAR_WHATSAPP": {
    name: "Whatsapp",
    category: 'contactUs',
    icon: `${TENANT_BUCKET}/icon/sideBar_whatsapp.png`,
  },

  "SIDEBAR_WECHAT": {
    name: "Wechat",
    category: 'contactUs',
    icon: `${TENANT_BUCKET}/icon/sideBar_wechat.png`,
  },


  "TIKTOK": {
    name: "TikTok",
    category: 'socialMedia',
    icon: `${GLOBAL_BUCKET}/social/tiktok.png`,
  },

  "YOUTUBE": {
    name: "YouTube",
    category: 'socialMedia',
    icon: `${GLOBAL_BUCKET}/social/youtube.png`,
  },

  "TWITTER": {
    name: "Twiiter",
    category: 'socialMedia',
    icon: `${GLOBAL_BUCKET}/social/twitter.png`,
  },

  "INSTAGRAM": {
    name: "Instagram",
    category: 'socialMedia',
    icon: `${GLOBAL_BUCKET}/social/instagram.png`,
  },

  "FACEBOOK": {
    name: "Facebook",
    category: 'socialMedia',
    icon: `${GLOBAL_BUCKET}/social/facebook.png`,
  },
}

// ---------- GAME WALLET CATEGORY ----------
export const GAME_WALLET_CATEGORY = [
  ["SL", "LC", "FH", "APP"], ["SB", "ES"], ["CB", "LK", "PK", "MG"]
]

// ---------- HISTORY TABLE FIELD ----------
export const HISTORY_TABLE_FIELD = {

  "TRANSFER": {
    id: "TRANSFER",
    allAttr: ["transaction_date", "type", "currency", "amount", "target_login"],
    selectedTableColumn: ["transaction_date", "type", "currency", "amount", "target_login"]
  },

  "MEMBER": {
    id: "MEMBER",
    allAttr: ["member", "registered_date", "currency", "ftd_date", "ftd_amount"],
    selectedTableColumn: ["member", "registered_date", "currency", "ftd_date", "ftd_amount"]
  },

  "DEPOSIT": {
    id: "DEPOSIT",
    allAttr: ["transaction_date", "amount", "status"],
    selectedTableColumn: ["transaction_date", "amount", "status"],
  },

  "WITHDRAW": {
    id: "WITHDRAW",
    allAttr: ["transaction_date", "currency", "amount", "status"],
    selectedTableColumn: ["transaction_date", "currency", "amount", "status"],
  },

  "MONTHLY_WIN_LOSS": {
    id: "MONTHLY_WIN_LOSS",
    allAttr: ["member", "game_provider", "company_wl", "turnover"],
    selectedTableColumn: ["member", "month", "company_wl", "turnover"],
  },

  "MONTHLY_COMMISSION": {
    id: "MONTHLY_COMMISSION",
    allAttr: ["provider_details", "company_wl","other_cost","royalty_fee_rate","royalty_fee", "bonus","actual_rebate","commission_rate","calculated_commission"],
    allAttr2: ["currency", "calculated_commission", "other_cost", "commission_rate","final_other_cost","final_calculated_commission"],
    selectedTableColumn: ["comm_month", "currency", "active_member", "win_loss","shared_cost","commission_rate","calculated_commission","last_month_carry_forward","commission","carry_forward","actual_release","status"],
  },

  "BONUS": {
    id: "BONUS",
    allAttr: ["from", "to", "amount", "transaction_date", "transaction_status"],
    selectedTableColumn: ["to", "amount", "transaction_status"]
  },
}

export const IMAGE_SIZE_DYNAMIC = {
  '1x1': {
    'desktop': {
      'none': {
        4: 320,
        5: 240,
        6: 240,
        7: 150,
      },
      'right': {
        2: 320,
        3: 240
      },
      'bottom': {
        4: 320,
        5: 240,
        6: 240,
        7: 150,
      },
      'insideImage': {
        4: 320,
        5: 240,
        6: 240,
        7: 150,
      },
    },
    'mobile': {
      'none': {
        2: 150,
        3: 150,
        4: 150,
      },
      'right': {
        1: 150,

      },
      'bottom': {
        2: 150,
        3: 150,
        4: 150,
      }, 'insideImage': {
        2: 150,
        3: 150,
        4: 150,
      }
    }
  },
  '1x2': {
    'desktop': {
      'none': {
        2: 750,
        3: 480,
        4: 320,
        5: 320,
        6: 320,
      },
      'right': {
        1: 750,
        2: 320
      },
      'bottom': {
        2: 750,
        3: 480,
        4: 320,
        5: 320,
        6: 320,
      },
      'insideImage': {
        2: 750,
        3: 480,
        4: 320,
        5: 320,
        6: 320,
      },
    },
    'mobile': {
      'none': {
        1: 320,
        2: 320,
        3: 320,
      },
      'right': {
        1: 320,

      },
      'bottom': {
        2: 320,
        3: 320,
        4: 320,
      },
      'insideImage': {
        2: 750,
        3: 480,
        4: 320,
        5: 320,
        6: 320,
      },
    }
  }
}